function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebookinline = function SvgFacebookinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11 0a11 11 0 1 0 11 11A11 11 0 0 0 11 0Zm2.992 6.408a.3.3 0 0 1-.28.272h-1.119a.731.731 0 0 0-.909.886V8.8h1.953a.261.261 0 0 1 .21.069.247.247 0 0 1 .07.2v2.112a.3.3 0 0 1-.28.272H11.68v5.377a.3.3 0 0 1-.28.272H9.237a.3.3 0 0 1-.28-.272v-5.381H7.28a.3.3 0 0 1-.28-.272V9.065a.3.3 0 0 1 .279-.265h1.678V7.292a2.921 2.921 0 0 1 3.076-3.2h1.678a.248.248 0 0 1 .05 0 .253.253 0 0 1 .232.273v2.043Z",
    style: {
      fill: "#282828",
      fillRule: "evenodd"
    }
  }));
};
export default SvgFacebookinline;